<template>
  <div class="row-box">
    <template v-if="data.notificants.length > 0">
      <div class="form-base__title preview break">
        Для выполнения процессуальных действий по обеспечению доказательств
        направить извещение следующим сторонам/заинтересованным лицам (если
        таких лиц несколько, раздел заполняется в отношении каждого)
      </div>
      <div
        v-for="(notificant, index) in data.notificants"
        :key="`notificant${index}${Math.random()}`"
      >
        <div class="form-base__title preview break">
          Заинтересованное лицо №{{ index + 1 }}
        </div>

        <div class="row-box mb-5">
          <Person :data="notificant" v-if="notificant.person" />
          <Organization :data="notificant" v-if="notificant.organization" />
          <ForeignOrganization
            :data="notificant"
            v-if="notificant.foreignOrganization"
          />
        </div>
      </div>
    </template>

    <template v-else>
      <div class="form-base__title preview break">
        Обеспечить доказательства без извещения сторон и заинтересованных лиц
      </div>
      <div v-if="data.noSubjectUrgentCase" class="input-raw break">
        <text-field-tooltip
          value="В связи со случаем, не терпящим отлагательства"
          :label="null"
        />
      </div>
      <div v-if="data.noSubjectUnknownSubjectsCase" class="input-raw break">
        <text-field-tooltip
          value="В связи с тем, что нельзя определить, кто впоследствии будет участвовать в деле"
          :label="null"
        />
      </div>
    </template>
  </div>
</template>

<script>
import TextFieldTooltip from '@/components/elements/statement/FullStatementView/base/TextFieldTooltip';
import Person from '@/components/elements/statement/FullStatementView/elements/Person';
import Organization from '@/components/elements/statement/FullStatementView/elements/Organization';
import ForeignOrganization from '@/components/elements/statement/FullStatementView/elements/ForeignOrganization';

export default {
  name: 'Step3',
  components: {
    TextFieldTooltip,
    ForeignOrganization,
    Organization,
    Person,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
  }),
};
</script>
